import React from 'react';
import Tooltip from '@mui/material/Tooltip';
import withStyles from '@mui/styles/withStyles';

const TP = withStyles({
  tooltip: {
    fontSize: '15px',
  },
})(Tooltip);

const MyTooltip = ({ render, title, placement }) => {
  return (
    <>
      <TP
        title={title}
        enterTouchDelay={0}
        placement={placement ? placement : 'bottom'}
        arrow
      >
        {render()}
      </TP>
    </>
  );
};

export default MyTooltip;
